var BOOLEAN_ATTRIBUTES = [
    'required',
    'readonly',
    'readOnly',
    'multiple',
    'formnovalidate',
    'formNoValidate',
    'disabled',
    'checked',
    'autofocus',
    'autFocus',
];
function useAttributesWatcher(element, callback) {
    var mutationObserver = new MutationObserver(function () {
        callback(calculateAttributes());
    });
    mutationObserver.observe(element, { attributes: true });
    callback(calculateAttributes());
    return function () {
        mutationObserver.disconnect();
    };
    function calculateAttributes() {
        var attributes = getElementAttributes(element.attributes);
        return _omit(attributes, ['id', 'style', 'class']);
    }
    function getElementAttributes(nodeMap) {
        if (nodeMap) {
            var length_1 = nodeMap.length;
            return Object.keys(nodeMap).reduce(function (props, current) {
                var _a;
                var numCurrent = parseInt(current);
                if (numCurrent < length_1) {
                    var property = nodeMap[current];
                    return Object.assign(Object.assign({}, props), (_a = {}, _a[property.name] = BOOLEAN_ATTRIBUTES.includes(property.name) && property.value === '' ? true : property.value, _a));
                }
            }, {});
        }
        return {};
    }
}
function _omit(obj, keys) {
    return Object.keys(obj).reduce(function (agg, key) {
        if (keys.indexOf(key) === -1) {
            agg[key] = obj[key];
        }
        return agg;
    }, {});
}
export { useAttributesWatcher as u };
